import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {AthleteGameLineupsRepository} from "./athlete-game-lineups.repository";
import {AthleteGameLineupsFactory} from "./athlete-game-lineups.factory";

export class AthleteGameLineupsDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, AthleteGameLineupsRepository, AthleteGameLineupsFactory, DomainRequestManager, AthleteGameLineupsFactory];
}